import styled from 'styled-components';

export const StyledContainer = styled.div`
  padding: 20px 16px 0px 16px;
  height: 100vh;
  display: flex;
  flex-direction: column;
`;
